import { invariant } from '../../utils';
export var BemToolsManager = /*#__PURE__*/function () {
  function BemToolsManager(designer) {
    this.designer = void 0;
    this.toolsContainer = [];
    this.designer = designer;
  }
  var _proto = BemToolsManager.prototype;
  _proto.addBemTools = function addBemTools(toolsData) {
    var found = this.toolsContainer.find(function (item) {
      return item.name === toolsData.name;
    });
    invariant(!found, toolsData.name + " already exists");
    this.toolsContainer.push(toolsData);
  };
  _proto.removeBemTools = function removeBemTools(name) {
    var index = this.toolsContainer.findIndex(function (item) {
      return item.name === name;
    });
    if (index !== -1) {
      this.toolsContainer.splice(index, 1);
    }
  };
  _proto.getAllBemTools = function getAllBemTools() {
    return this.toolsContainer;
  };
  return BemToolsManager;
}();